<template>
  <StepCard title="Documentos e Justificativa">
    <v-row>
      <v-col cols="12">
        <div v-for="documento in listaDocumentos" :key="documento.name" class="mb-2">
          <v-checkbox v-model="documento.selected" :label="`${documento.name}${documento.required ? ' *' : ''}`"
            density="compact" hide-details></v-checkbox>
          <div v-if="documento.selected" class="pl-8 mt-n2">
            <v-file-input
              :key="documento.name + '-file'"
              @update:model-value="addFiles(documento, $event)"
              label="Adicionar arquivo(s)"
              variant="outlined"
              density="compact"
              :error-messages="documento.error"
              :error="!!documento.error"
              multiple
              hide-details
            >
              <template #selection></template>
            </v-file-input>

            <v-list v-if="documento.files && documento.files.length > 0" density="compact" class="mt-1">
              <v-list-item v-for="(file, index) in documento.files" :key="index" class="py-0">
                <v-list-item-title class="text-caption">{{ file.name }}</v-list-item-title>
                <template v-slot:append>
                  <v-btn
                    icon="mdi-delete"
                    size="x-small"
                    variant="text"
                    @click="removeFile(documento, index)"
                  ></v-btn>
                </template>
              </v-list-item>
            </v-list>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-divider class="my-4"></v-divider>
    <v-textarea v-model="justificativa" label="Justificativa *"
      placeholder="Descreva o motivo da escolha de um prestador fora da rede (ex: indisponibilidade de especialista, urgência, etc.)"
      variant="outlined" class="mt-2" rows="3" auto-grow
      counter="3000" maxlength="3000"
      :error-messages="mostrarErroJustificativa && !justificativa.trim() ? 'A justificativa é obrigatória.' : ''">
    </v-textarea>
    <v-alert v-if="mostrarErroDocumentos" type="error" density="compact" class="mt-4"
      text="Por favor, anexe todos os documentos obrigatórios (*)."></v-alert>
  </StepCard>
</template>

<script setup>
import { watch } from 'vue';
import StepCard from './StepCard.vue';

const listaDocumentos = defineModel('listaDocumentos', { type: Array, required: true });
const justificativa = defineModel('justificativa', { type: String, required: true });

defineProps({
  mostrarErroDocumentos: { type: Boolean, default: false },
  mostrarErroJustificativa: { type: Boolean, default: false },
});

watch(listaDocumentos, (currentDocs) => {
  if (currentDocs.some(d => d.selected && !d.files)) {
    listaDocumentos.value = currentDocs.map(doc => {
      if (doc.selected && !doc.files) {
        return { ...doc, files: [] };
      }
      return doc;
    });
  }
}, { immediate: true, deep: true });

function addFiles(documento, newFiles) {
  if (!newFiles || newFiles.length === 0) return;

  const docIndex = listaDocumentos.value.findIndex(d => d.name === documento.name);
  if (docIndex === -1) return;

  const targetDoc = listaDocumentos.value[docIndex];
  const updatedFiles = [...(targetDoc.files || []), ...newFiles];

  const newDocs = [...listaDocumentos.value];
  newDocs[docIndex] = {
    ...targetDoc,
    files: updatedFiles,
  };
  listaDocumentos.value = newDocs;
}

function removeFile(documento, index) {
  const docIndex = listaDocumentos.value.findIndex(d => d.name === documento.name);
  if (docIndex === -1) return;

  const targetDoc = listaDocumentos.value[docIndex];
  if (!targetDoc.files) return;

  const updatedFiles = [...targetDoc.files];
  updatedFiles.splice(index, 1);

  const newDocs = [...listaDocumentos.value];
  newDocs[docIndex] = {
    ...targetDoc,
    files: updatedFiles,
  };
  listaDocumentos.value = newDocs;
}
</script>